/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React, { useState } from 'react';
import { Search, Car, Wrench, Sofa, Dog, Leaf } from 'lucide-react';
import { useTheme } from '../theme';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';
import { itemService } from '../services/itemService';

const Hero: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
    { name: 'Vehicles', icon: <Car size={24} /> },
    { name: 'Tools', icon: <Wrench size={24} /> },
    { name: 'Furniture', icon: <Sofa size={24} /> },
    { name: 'Pets', icon: <Dog size={24} /> },
    { name: 'Garden', icon: <Leaf size={24} /> },
  ];

  return (
    <div className="py-16 md:py-24 text-center">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6" style={{ color: theme.colors.text }}>
          Buy & Sell Locally
        </h1>
        <p className="text-xl md:text-3xl mb-12 opacity-80" style={{ color: theme.colors.text }}>
          Discover trusted sellers near you
        </p>

        {/* Large Search Bar */}
        <div className="relative max-w-3xl mx-auto mb-16">
          <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
            <Search size={28} style={{ color: theme.colors.mutedText }} />
          </div>
          <input
            type="text"
            placeholder="Search items, shops..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(searchQuery)}`);
              }
            }}
            className="block w-full pl-16 pr-6 py-6 text-xl border rounded-2xl shadow-2xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 transition-all"
            style={{ 
              backgroundColor: theme.colors.surface, 
              borderColor: theme.colors.border, 
              color: theme.colors.text,
            }}
          />
        </div>

        {/* Category Quick Links */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => navigate(`${ROUTES.SEARCH}?q=${encodeURIComponent(cat.name)}`)}
              className="group flex flex-col items-center gap-3 transition-transform hover:scale-110"
            >
              <div 
                className="w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center border shadow-sm group-hover:shadow-md transition-all"
                style={{ 
                  backgroundColor: theme.colors.surface, 
                  borderColor: theme.colors.border,
                  color: theme.colors.primary
                }}
              >
                {cat.icon}
              </div>
              <span className="font-bold text-sm md:text-base" style={{ color: theme.colors.text }}>{cat.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
